import React from "react"

import Layout from "../components/Layout"
import SEO from "@/components/SEO"
import { StaticImage } from "gatsby-plugin-image"
import { routes } from "../utils/routes"

type PageProps = {
  data: any
}

const ContactUs: React.FC<PageProps> = ({ data }) => (
  <Layout
    sectionOne={
      <>
        <div className="relative h-[67vh] md:min-h-[75vh]">
          <StaticImage
            src="../../static/images/school building photo.jpg"
            className="absolute inset-0 w-full h-full object-cover -z-50"
            alt="Contact Us"
          />
          <div className="absolute inset-0 bg-[#131312]/50 -z-40"></div>

            <div className="container text-white h-[67vh] md:min-h-[75vh] flex items-center px-4">
              <div className="pl-2 md:pl-6 lg:pl-10 max-w-[1000px] translate-y-10 md:translate-y-16 lg:translate-y-20">
                <div className="pb-4">
                  <h1
                    className="text-left text-white text-[300%] sm:text-[400%] md:text-[531.25%] leading-[1] font-bold normal-case tracking-normal font-gilroy"
                  >
                    Contact Us
                  </h1>
                  <div className="mt-5 h-[8px] sm:h-[10px] w-[200px] sm:w-[320px] bg-primary"></div>
                </div>
              </div>
            </div>
        </div>

        {/* Gold four-option bar below the fold */}
        <div className="bg-primary w-full h-[33vh] md:h-auto md:block">
          <div className="flex flex-col h-full w-full md:grid md:grid-cols-4 md:gap-0 md:items-stretch md:min-h-[84px]">
              <a href={routes.socialMobility()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Transformative Bursaries
              </a>
              <a href={routes.southWingDevelopment()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                The South Wing
              </a>
              <a href={routes.pledge()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] border-b border-white text-[19px] leading-[32.3px] md:border-b-0 md:border-r md:px-2">
                Sponsor a Paviour
              </a>
              <a href={routes.donate()} className="flex-1 flex items-center justify-center px-4 text-center uppercase font-gilroy font-bold text-[#131312] text-[19px] leading-[32.3px] md:px-2">
                Donate
              </a>
          </div>
        </div>
      </>
    }
  >
    <SEO title="Contact Us" />
    <div className="container py-14">
      <div className="flex justify-center">
        <div className="flex flex-col gap-4 max-w-[700px]">
          <h3 className="mb-4 text-3xl normal-case font-gilroy font-bold">
            Working with alumni, parents, and the wider <span className="text-primary">Instonian community</span>, the RBAI Foundation raises funds to <span className="text-primary">support the development of the School</span>.
          </h3>
          <p className="font-gilroy">
            Alumni also play an active role in supporting pupils through careers talks, mentoring, coaching and providing work experience.
          </p>
          <p className="font-gilroy">
            The RBAI Foundation acts as a hub for communication with 8,000 Instonians around the world, hosting alumni events across the UK and overseas, as well as promoting the Belfast Old Instonians Association (BOIA) annual dinners in Belfast, Edinburgh and London.
          </p>
          <p className="font-gilroy">
            To find out about alumni events, reconnect with old school friends or arrange a visit to the School, contact:
          </p>

          {/* Headshots - 3 columns on desktop, stacked on mobile */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {/* Peter - Left */}
            <div className="flex flex-col items-center">
              <img
                src="/images/Peter- Headshot.jpg"
                alt="Peter Anderson"
                className="w-full max-w-[300px] h-auto object-cover sm:max-w-full"
                style={{ aspectRatio: "3/4" }}
              />
              <div className="mt-4 sm:hidden">
                <p className="text-center font-gilroy">
                  <strong>Peter Anderson</strong>
                  <br />
                  RBAI Foundation Director
                  <br />
                  E:{" "}
                  <a
                    className="link underline hover:no-underline"
                    href="mailto:p.anderson@rbai.org.uk"
                  >
                    p.anderson@rbai.org.uk
                  </a>
                  <br />
                  T: 02890240461
                </p>
              </div>
            </div>

            {/* Sharon - Middle */}
            <div className="flex flex-col items-center mt-8 sm:mt-0">
              <img
                src="/images/Sharon-headshot.jpg"
                alt="Sharon Casement"
                className="w-full max-w-[300px] h-auto object-cover sm:max-w-full"
                style={{ aspectRatio: "3/4" }}
              />
              <div className="mt-4 sm:hidden">
                <p className="text-center font-gilroy">
                  <strong>Sharon Casement</strong>
                  <br />
                  RBAI Foundation Assistant
                  <br />
                  E:{" "}
                  <a
                    className="link underline hover:no-underline"
                    href="mailto:s.casement@rbai.org.uk"
                  >
                    s.casement@rbai.org.uk
                  </a>
                  <br />
                  T: 02890240461
                </p>
              </div>
            </div>

            {/* Zoe - Right */}
            <div className="flex flex-col items-center mt-8 sm:mt-0">
              <img
                src="/images/rbai_zoe.jpeg"
                alt="Zoe Cunningham"
                className="w-full max-w-[300px] h-auto object-cover sm:max-w-full"
                style={{ aspectRatio: "3/4", objectPosition: "center 20%" }}
              />
              <div className="mt-4 sm:hidden">
                <p className="text-center font-gilroy">
                  <strong>Zoe Cunningham</strong>
                  <br />
                  RBAI Foundation Communications Manager
                  <br />
                  E:{" "}
                  <a
                    className="link underline hover:no-underline"
                    href="mailto:z.cunningham@rbai.org.uk"
                  >
                    z.cunningham@rbai.org.uk
                  </a>
                  <br />
                  T: 02890240461
                </p>
              </div>
            </div>
          </div>

          {/* Team details - Desktop only (hidden on mobile as details are shown below photos) */}
          <div className="hidden sm:grid sm:grid-cols-3 gap-4 mt-4">
            <div className="mb-5">
              <p className="text-center font-gilroy">
                <strong>Peter Anderson</strong>
                <br />
                RBAI Foundation Director
                <br />
                E:{" "}
                <a
                  className="link underline hover:no-underline"
                  href="mailto:p.anderson@rbai.org.uk"
                >
                  p.anderson@rbai.org.uk
                </a>
                <br />
                T: 02890240461
              </p>
            </div>

            <div className="mb-5">
              <p className="text-center font-gilroy">
                <strong>Sharon Casement</strong>
                <br />
                RBAI Foundation Assistant
                <br />
                E:{" "}
                <a
                  className="link underline hover:no-underline"
                  href="mailto:s.casement@rbai.org.uk"
                >
                  s.casement@rbai.org.uk
                </a>
                <br />
                T: 02890240461
              </p>
            </div>

            <div className="mb-5">
              <p className="text-center font-gilroy">
                <strong>Zoe Cunningham</strong>
                <br />
                RBAI Foundation Communications Manager
                <br />
                E:{" "}
                <a
                  className="link underline hover:no-underline"
                  href="mailto:z.cunningham@rbai.org.uk"
                >
                  z.cunningham@rbai.org.uk
                </a>
                <br />
                T: 02890240461
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
)

export default ContactUs
